import React from "react";
import { connect } from "react-redux";
import { resetError, defineScopeLoading } from "actions/spendActions";
import { GetRiseSavingGraphDetails } from "actions/kpiActions";
import DoughnutChart from "components/UI/DoughnutChart";
import S4CostPanel from "./S4CostPanel";
import "./SavingContainer.css";

class SavingGraph extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      errorMsg: "",
      data: "",
    };
    this.loadData = this.loadData.bind(this);
    this.keysToLowerCase = this.keysToLowerCase.bind(this);
  }

  componentDidMount() {
    this.loadData();
  }

  keysToLowerCase(obj) {
    if (Array.isArray(obj)) {
      return obj.map((v) => this.keysToLowerCase(v));
    } else if (obj !== null && obj.constructor === Object) {
      return Object.keys(obj).reduce((acc, key) => {
        acc[key.toLowerCase()] = this.keysToLowerCase(obj[key]);
        return acc;
      }, {});
    }
    return obj;
  }

  loadData() {
    const dmcId = this.props.spendDetails.currentActiveRequest.DMC_ID;
    const vsId = this.props.spendDetails.currentActiveRequest.VS_ID;
    const user = this.props.user.user.Email;

    this.props.defineScopeLoading(true);
    this.props
      .GetRiseSavingGraphDetails(dmcId, vsId, user,500000,'R')
      .then((response) => {
        if (response.data.Result.Table.length > 0) {
          let spData = response.data.Result.Table;
          this.setState({ data: this.keysToLowerCase(spData) });
        } else {
          this.setState({ errorMsg: "No Records Found." });
        }
        this.props.defineScopeLoading(false);
      })
      .catch((error) => {
        this.props.defineScopeLoading(false);
        if (error.stack && error.stack.includes("Network Error")) {
          this.setState({
            errorMsg: "API service is down. Please contact administrator.",
          });
        } else {
          this.setState({ errorMsg: this.props.content.error });
        }
      });
  }

  handleSave = async (payload) => {
    // handle save logic here
    console.log("Saving S4 cost details:", payload);
    // You can call an API or redux action here if needed
    await new Promise((res) => setTimeout(res, 600));
  };

  render() {
    return (
      <div
        style={{
          height: "420px",
          border: "1px solid #ddd",
          borderRadius: "8px",
          boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
          display: "flex",
          flexDirection: "row", // side-by-side layout
          justifyContent: "space-between",
          alignItems: "stretch",
          margin: "20px auto",
          backgroundColor: "#fff",
          overflow: "hidden",
        }}
      >
        {/* Doughnut Chart - 70% width */}
        <div
          style={{
            flex: "0 0 60%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderRight: "1px solid #eee",
            padding: "10px",
          }}
        >
          <DoughnutChart data={this.state.data} />
        </div>

        {/* S4 Cost Panel - 30% width */}
        <div
          style={{
            flex: "0 0 40%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            padding: "10px 16px",
          }}
        >
          <S4CostPanel onSave={this.handleSave} />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    ui: state.content.ui,
    userData: state.valueStory,
    user: state.default,
    content: state.content.spendAnalysis.worldMap,
    focusLabel: state.content.spendAnalysis.enablement.focusLabel,
    spendDetails: state.spendDetails,
    currencySymbols: state.content.CurrencySymbols,
    kpiFilters: state.kpis.kpiBenchMarkFilters,
    kpiLables: state.content.kpiTab,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    resetError: (error) => dispatch(resetError(error)),
    defineScopeLoading: (bool) => dispatch(defineScopeLoading(bool)),
    GetRiseSavingGraphDetails: (DMCId, VSId, userEmail,COST_S4_PROJ,REC_FLAG) =>
      dispatch(GetRiseSavingGraphDetails(DMCId, VSId, userEmail,COST_S4_PROJ,REC_FLAG)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SavingGraph);
